import axios from "axios";
import { Uploader } from "../../../handlers";
import { UploadSaveFailed } from "../../../handlers/errors";
class Uploads extends Uploader {
    constructor(sdk) {
        super(sdk);
        this.url = `${this.sdk.urls.baseAPIUrl}/pub_groups_csv`;
    }
    async saveUpload(file) {
        const blob = new Blob([file], {
            type: "application/json; charset=utf-8;"
        });
        return axios
            .post(`${this.url}`, blob, {
            headers: {
                Accept: "application/json"
            }
        })
            .then(({ data: res }) => {
            return res.data;
        })
            .catch((err) => {
            throw new UploadSaveFailed(err, "Failed to create publisher allow list from template.");
        });
    }
}
export default Uploads;
//# sourceMappingURL=uploads.js.map